import { render, staticRenderFns } from "./SocialSecurityItem.vue?vue&type=template&id=dfdf3e6a&scoped=true"
import script from "./SocialSecurityItem.vue?vue&type=script&lang=js"
export * from "./SocialSecurityItem.vue?vue&type=script&lang=js"
import style0 from "./SocialSecurityItem.vue?vue&type=style&index=0&id=dfdf3e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfdf3e6a",
  null
  
)

export default component.exports